import React, { useEffect, useState } from "react";
import { qrtListAuditLog } from "../../apis/qrtAdmin";
import { Pager, Spinner, fmtDateTime, num } from "./qrtUi";

const PAGE_SIZE = 50;

const QrtAudit = () => {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(0);

  useEffect(() => {
    qrtListAuditLog({ limit: PAGE_SIZE, offset: page * PAGE_SIZE })
      .then((res) => setData(res.data?.data || { rows: [], total: 0 }))
      .catch(() => setData({ rows: [], total: 0 }));
  }, [page]);

  if (!data) return <Spinner />;

  return (
    <div>
      <div className="qrt-page-head">
        <div>
          <h2>Audit log</h2>
          <p>{num(data.total)} recorded admin actions</p>
        </div>
      </div>

      <div className="qrt-card">
        <table className="qrt-table">
          <thead>
            <tr>
              <th>Admin</th>
              <th>Action</th>
              <th>Target</th>
              <th>Reason</th>
              <th className="r">When</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.id}>
                <td>
                  <div style={{ fontWeight: 600 }}>{r.admin_name || `#${r.admin_user_id}`}</div>
                  <div className="sub">{r.admin_email}</div>
                </td>
                <td className="mono">{r.action}</td>
                <td className="sub">{r.target_type} {r.target_id}</td>
                <td className="sub" style={{ maxWidth: 260, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {r.reason || "—"}
                </td>
                <td className="r sub">{fmtDateTime(r.created_at)}</td>
              </tr>
            ))}
            {data.rows.length === 0 && (
              <tr><td className="empty" colSpan={5}>No admin actions logged yet</td></tr>
            )}
          </tbody>
        </table>
        <Pager page={page} total={data.total} pageSize={PAGE_SIZE} onPage={setPage} />
      </div>
    </div>
  );
};

export default QrtAudit;
